import deviceUtils from "@/utils/device";
import _ from 'lodash'

export function isIos() {
    return deviceUtils.isIos()
}

export function isAndroid() {
    return deviceUtils.isAndroid()
}


class JsBridge {
    static invokeMethod(methodName, callbackOrOptions, callback) {
        const args = arguments;
        const nativeFuncName = methodName;
        const webPlatformCallbackName = 'callback' + this.generateRandomKey(32);
        let webPlatformCallback;
        const options = {
            webPlatformCallbackName: webPlatformCallbackName,
            params: {}
        };
        if (args.length === 2) {
            if (Object.prototype.toString.call(args[1]) === "[object Object]") {
                options.params = args[1];
            }
            else if (Object.prototype.toString.call(args[1]) === "[object Function]") {
                webPlatformCallback = args[1];
            }
        }
        else if (args.length === 3) {
            options.params = args[1];
            webPlatformCallback = args[2];
        }
        return new Promise((resolve, reject) => {
            if (isAndroid()) {
                if (window.Assistant) {
                    // @ts-ignore
                    if (webPlatformCallback) {
                        window[webPlatformCallbackName] = function (result) {
                            let data;
                            try {
                                data = JSON.parse(result);
                            }
                            catch (_a) {
                                data = result;
                            }
                            webPlatformCallback && webPlatformCallback(data);
                            Reflect.deleteProperty(window, webPlatformCallbackName);
                            resolve(data);
                        };
                    }
                    window.Assistant.jsBridgeInvokeMethod(nativeFuncName, JSON.stringify(options));
                }
            }
            else if (isIos()) {
                if (window.webkit && window.webkit.messageHandlers) {
                    // @ts-ignore
                    if (webPlatformCallback) {
                        window[webPlatformCallbackName] = function (result) {
                            let data;
                            try {
                                data = JSON.parse(result);
                            }
                            catch (_a) {
                                data = result;
                            }
                            webPlatformCallback && webPlatformCallback(data);
                            Reflect.deleteProperty(window, webPlatformCallbackName);
                            resolve(data);
                        };
                    }
                    window.webkit.messageHandlers.NativeApi.postMessage(Object.assign({ func: "jsBridgeInvokeMethod", nativeFuncName: nativeFuncName }, options));
                }
            }
        });
    }

    static generateRandomKey(length = 12) {
        const arr = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
        let str = '';
        for (let i = 0; i < length; i++) {
            str += arr[Math.floor(Math.random() * arr.length)];
        }
        return str;
    }
}
export default JsBridge;


function bindCallbackOnWindow (fn, callbackName, autoexecute) {
    return new Promise((resolve, reject) => {
        const tmpName = _.isString(callbackName) ? callbackName : 'callback' + JsBridge.generateRandomKey(32);
        window[tmpName] = async (...args) => {
            window[tmpName] = null;
            delete window[tmpName];
            try {
                resolve(args)
            } catch (e) {
                reject(e)
            }
        };
        fn(tmpName)
        if(autoexecute) {
            setTimeout(() => {
                reject(null)
            }, 300)
        }
    })
}

/**
 * 抖音登录
 * @param callbackName 
 */
 function androidGetDouyinLoginCode(callbackName) {
    try {
        window.Assistant.getDouyinLoginCode(callbackName)
    } catch {
        throw new Error('暂无安卓客户端授权！')
    }
}

function iosGetDouyinLoginCode(callbackName) {
    try {
        window.webkit.messageHandlers.NativeApi.postMessage( {"func":"getDouyinLoginCode", "param": callbackName})
    } catch {
        throw new Error('暂无ios客户端授权！')
    }
}
export async function dyLogin () {
    const login = isAndroid() ? androidGetDouyinLoginCode : iosGetDouyinLoginCode
    return await bindCallbackOnWindow(login)
}
/**
 * 微信登录
 */
 const wxLoginCallback = 'wxLoginCallback'
function iosWxLogin (callbackName) {
    try{
        window.webkit.messageHandlers.NativeApi.postMessage({"func": "getWxLoginCode", "param": callbackName});
    }catch(e){
        throw new Error('暂无IOS客户端授权！')
    }
}
export async function wechatLogin () {
    if (deviceUtils.isProducerApp() || deviceUtils.isHarmony() || deviceUtils.isAndroid()) {
        try{
            const res = await window.Capacitor.Plugins.WeChat.login();
            return res.value;
        }catch(e){
            throw new Error('微信登录异常')
        }
    } else {
        const res =  await bindCallbackOnWindow(iosWxLogin, wxLoginCallback)
        if (res[0]) {
            return res[0]
        } else {
            throw new Error('微信登录异常')
        }
    }
}


// 安卓持久化cookie
export function androidPersistentCookie() {
    try{
        window.Assistant.updateCookie()
    }catch(e){
        ;
    }
}


/**
 * app拉起小程序
 * @param userName 小程序账号原始id
 * @param path 跳转链接
 * @param miniProgramType 0：正式版、1：开发版、2：体验版，调试时可以动态切换 window.miniProgramType
 */
 export function launchMiniProgram(userName, path, miniProgramType) {
    if (typeof miniProgramType !== 'number') {
        process.env.NODE_ENV === 'production' ? (miniProgramType = 0) : (miniProgramType = 2)
    }
    if(isAndroid()) {
        try {
            window.Assistant.goToApplet(userName, path, miniProgramType);
        } catch(e){
            throw new Error('app拉起小程序失败。错误信息：'+e)
        }
    } else {
        const param = {
			userName: userName,
			path: path,
			miniProgramType: miniProgramType
		};
        try {
            window.webkit.messageHandlers.NativeApi.postMessage({"func":"launchMiniProgram", "param":param});
        } catch(e){
            throw new Error('您的当前版本过低，请前往AppSrote版本。错误信息：'+e)
        }
    }
}